export const PREVIEW_PROTOCOL = Object.freeze({
  version: 1,
  identitySwitchTimeoutMs: 15000,
  messages: Object.freeze({
    ready: "welliemd:preview:ready",
    resize: "welliemd:preview:resize",
    navigation: "welliemd:preview:navigation",
    close: "welliemd:preview:close",
    error: "welliemd:preview:error",
    identity: "welliemd:preview:identity",
    identityReady: "welliemd:preview:identity-ready",
    identityState: "welliemd:preview:identity-state",
    refresh: "welliemd:preview:refresh",
  }),
  events: Object.freeze({
    identityChanged: "welliemd:preview-identity-changed",
    identityReady: "welliemd:preview-identity-ready",
  }),
  identities: Object.freeze({
    newPatient: "new_patient",
    existingPatient: "existing_patient",
  }),
  patientDefaults: Object.freeze({
    dateOfBirth: "1988-06-15",
    sex: "female",
    state: "FL",
    bmi: 30,
  }),
});
